import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import StudentProfile from "./Student"
import Dashboard from "./dashboard";
import Layouts from "./Layouts";
import { useDispatch } from "react-redux";
import { getTeacherDetails } from "../../appRedux/actions/Dashboard";
import ClassSession from "./ClassSession";

const Main = ({ match }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTeacherDetails())
    
  }, []);
  
  return (<Switch>
    <Route path={`${match.url}/dashboard`} component={Dashboard} />
    <Route path={`${match.url}/student/:studentid`} component={StudentProfile} />
    <Route path={`${match.url}/class_assignment/:session_id`} component={ClassSession} />
    {/* <Route path={`${match.url}/widgets`} component={Widgets}/>
    <Route path={`${match.url}/metrics`} component={Metrics}/> */}
    <Route path={`${match.url}/layouts`} component={Layouts} />
    {/* <Route path={`${match.url}/algolia`} component={asyncComponent(() => import('../algolia'))}/> */}
  </Switch>)
}


export default Main;
